import { useEffect } from 'react';
import { confirm } from '@mildang/design-system-legacy/esm/components/molecules/dialog/ConfirmDialog/extends/confirm';
import { useStore } from './ConcurrentAuthAlertStore';

export function ConcurrentAuthAlert() {
  const { show } = useStore();

  useEffect(() => {
    if (show) {
      confirm({
        id: 'concurrent-auth-alert',
        title: '동시 접속으로\n로그아웃 되었습니다.',
        desc: '다른 기기에서 해당 계정으로 동시 접속되어, 보안을 위해 자동으로 로그아웃 되었습니다.',
        confirmText: '확인',
        confirmButtonProps: {
          variant: 'contained',
          color: 'primary',
        },
        dialogProps: {
          onClose: () => {},
        },
      }).then(() => {
        window.location.href = process.env.NEXT_PUBLIC_AIDT_PORTAL_HOST ?? '/';
      });
    }
  }, [show]);

  return null;
}
